/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import {
	Box,
	Typography,
	Button,
	InputLabel,
	Accordion,
	Divider,
	IconButton,
	Tooltip,
	Link
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import previewElementStyle, { StyledAccordianDetail } from './PeviewElements.style';
import {
	DIMENSION,
	MEASURES,
	CLEAR_ALL,
	TIME,
	CUSTOM_ATTRIBUTE,
	PARENT_CUST_ATTR,
	FUTURE_VALID_LIST,
	FILTER_CONDITION_LABELS,
	CANNED_REPORT_LIST,
	NO_MATCH,
	MAX_SELECTED_COLUMNS,
	LINK_ACTIVITY_DESELECTION_TOAST_REMOVE,
	LINK_ITEMS_NUM_BTN_TEXT,
	LINK_ACTIVITY_DESELECTION_TOAST,
	LINK_ACTIVITY_DESELECTION_TOAST_BTN,
	MOD_TMPT_LIST,
	CHARTER_ONLY_DATA,
	ITEM_SHARE_SELECTION,
	SSI_STORE_TRAIT_ATTRS,
	SSI_STORE_TRAIT_ADDITION_TOOLTIP,
	SSI_STORE_TRAIT_REMOVAL_TOOLTIP,
	STR_TMPT_LIST,
	ALL_LINK_ITEM_LIST,
	ENTERPRISE_INVENTORY,
	PURCHASE_ORDER_LIST,
	OTIF_TMPT_LIST,
	OMNI_TMPT_LIST,
	CHARTER,
	PERSONA,
	OMNI_BUNDLESELECT_MAP,
	PIVOT_COLUMN_LIMIT,
	SELECTED_COLUMN_LIMIT,
	SHOW_AS_CANNED_REPORT,
	UNSAVED_DATASET,
	DATASET_TOOLTIP,
	INITIAL_SSI_COMPATIBILITY,
	CUSTOM_DATASET_ID,
	FILTER_LOWER,
	LY_PROTIP_TEXT,
	LEARN_MORE,
	PROTIP_LEARN_MORE,
	PROTIP_LEARN_MORE_BASIC,
	ATTRIBS_LOWERCASE,
	DEFAULT_VARIANT_SELECTION,
	ITEM_ACCESS_TYPE,
	ECOMM_INSTOCK_LIST,
	ECOMM_INSTOCK_PERCENTAGE_MEASURES,
	ECOMM_INSTOCK_FC_MEASURES,
	TIME_BUSINESS_NAMES
} from 'constants/constant';
import {
	setSelectedList,
	setFilterList,
	addPreviewColumn,
	removePreviewColumn,
	clearPreview,
	setPrevFilterList,
	setHierarchy,
	resetPivotOptions,
	saveItemShareStatus
} from '../Preview.actions';
import { setStartTour as setStartTourAction } from 'components/UserTour/Tour.action';
import { updateCustomDataset, saveCustomDataset } from 'components/Template/Template.actions';
import TimeFrame from '../timeframe/TimeFrame.component';
import { deepClone } from 'helper/helper';
import AttrList from '../timeframe/AttrList.component';
import { PreviewListItemContext, PreviewElementContext } from '../Preview.context';
import { StyledAccordionSummary } from '../timeframe/TimeFrame.style';
import PreviewSearch from './PreviewSearch';
import Tour from 'components/UserTour/Tour';
import {
	PreviewElementSteps,
	PreviewElementStepsWOTime,
	BasicPreviewElementSteps,
	BasicPreviewElementStepsWOTime
} from 'components/UserTour/Steps';
import {
	getDfltFilter,
	getTmplName,
	isCustomDataset,
	getSavedCustomDatasetWithAttributes,
	getBaseUrl,
	isBasicPersona,
	computeIncompatibilityObject
} from 'helper/utils';
import { UserPortalContext } from 'context/appcontext';
import { build } from 'helper/build';
import { FEATURES } from 'helper/basicFeatureFlag';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import WarningIcon from '@material-ui/icons/Warning';
import {
	createFolders,
	hasPivotedColumn,
	transformPinnedAttribute,
	calculateTotalColumnCount,
	findAppliedTimeFilterCountForPivot,
	isVariantAttrInTheList
} from '../Preview.utils';
import CloseIcon from '@material-ui/icons/Close';
import RBSnackbar from 'components/Shared/RBSnackbar';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import PinnedDataFolder from './PinnedDataFolder.component';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import { MenuItemsList } from 'components/Template/custom-template/Components/MenuItemsList.component';
import { CustomTemplateMain } from '../../Template/custom-template/CustomTemplateMain';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import TimeRangeSelection from '../timeframe/TimeRangeSelection.component';
import SaveDatasetModel from '../../Template/custom-template/Components/SaveDatasetModal';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import datasetIcon from 'assets/svgs/dataset.svg';
import { trackEventInfo } from 'helper/analytics';
import { PAGE_ID, EVENTS, ACTION_ON } from 'constants/tracker';
import ProTipComponent from './ProTipComponent';
import classNames from 'classnames';
import { isCalFamily } from '../filter/FilterCondition';

const EDIT_DATASET = 'Edit dataset';
const SAVE_DATASET = 'Save dataset';
const RENAME_DATASET = 'Rename dataset';

const EDIT_DATASET_OPTION = {
	disabled: false,
	name: EDIT_DATASET,
	icon: <EditOutlinedIcon />,
	id: EDIT_DATASET
};

const SAVE_DATASET_OPTION = {
	disabled: false,
	name: SAVE_DATASET,
	icon: <SaveOutlinedIcon />,
	id: SAVE_DATASET
};

const RENAME_DATASET_OPTION = {
	disabled: false,
	name: RENAME_DATASET,
	icon: <BorderColorIcon />,
	id: RENAME_DATASET
};

const PeviewElements = (props) => {
	const {
		setSelectedListCount,
		selectedListCount,
		setTotalSelected,
		actionOnGuidedBtn,
		drawerWidth,
		panelObjHeader,
		panelObjIcon,
		panelObjFromWhere,
		usrSelection = [],
		cbSSIComptability,
		ssiCompatibility,
		mtsSubAttr
	} = props;
	const classes = previewElementStyle();
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, customerType, isStudent } = portalUserContext;
	const { userPersona } = userDetails?.result;
	const [selectedTemplateData, setSelectedTemplateData] = useState(null);
	const [checked, setChecked] = useState([]);
	const [clear, setClear] = useState(false);
	const [anchorElement, setAnchorElement] = useState();
	const [totalAttributes, setTotalAttributes] = useState(0);
	const [folders, setFolders] = useState([]);
	const [expanded, setExpanded] = useState([TIME]);
	const [showProTip, setShowProTip] = useState(true);
	const [searchQuery, setSearchQuery] = useState('');
	const dispatch = useDispatch();
	const { cbSetShowPreviewElement, cbSetFilterTooltip } = useContext(PreviewElementContext);
	const {
		DISABLE_CUSTOM_ATTRIBUTE: disableCustomAttribute,
		DISABLE_ATTRIBUTE: disableAttribute,
		ENABLE_PINNED_ATTRIBUTE: enablePinnedAttribute
	} = FEATURES[customerType].PREVIEW_PAGE;
	const moreRef = useRef(null);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const customDatasetName = useSelector((state) => state.templateReducer.customDatasetName);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const customAttribute = useSelector((state) => state.templateReducer.customAttribute);
	const selectedList = useSelector((state) => state.previewReducer.selectedList);
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const previewData = useSelector((state) => state.previewReducer.previewData);
	const linkItemActivity = useSelector((state) => state.previewReducer.linkItemActivity);
	const hierarchy = useSelector((state) => state.previewReducer.hierarchy);
	const { showPreviewElementsTour, CDTourStepIndex } = useSelector((state) => state.tourReducer);
	const mandatorySelection = useSelector((state) => state.previewReducer.mandatorySelection);
	const { itemShareStatus, pinnedAttribute, pivotOpts } = useSelector(
		(state) => state.previewReducer
	);

	const [runTour, setRunTour] = useState(false);
	const [openSnackbar, setSnackbar] = useState({ open: false, msg: '' });
	const [tourSteps, setTourSteps] = useState(
		customerType === 'BASIC' ? BasicPreviewElementSteps : PreviewElementSteps
	);
	const [metricCalcAttr, setMetricCalcAttr] = useState(ssiCompatibility);
	const [showEditDataset, setShowEditDataset] = useState(false);
	const [showRenameDataset, setShowRenameDataset] = useState(false);
	const [isEditDatasetMode, setIsEditDatasetMode] = useState(true);

	const isBasic = isBasicPersona(portalUserContext.customerType);

	const selectedCustomDataset = useMemo(() => {
		const savedCustomDataset = savedCustomDatasets?.find(
			(dataset) => dataset.customDatasetName === customDatasetName
		);
		if (savedCustomDataset) {
			return savedCustomDataset;
		}
		// If the user goes to an unsaved dataset, then we assume the user has selected an "unsaved" custom dataset
		return templateData.find((template) => template?.templateId === CUSTOM_DATASET_ID);
	}, [customDatasetName, savedCustomDatasets, templateData]);

	const CUSTOM_TEMPLATE_OPTIONS_LIST = useMemo(() => {
		if (customDatasetName?.trim().length === 0) {
			return [EDIT_DATASET_OPTION, SAVE_DATASET_OPTION];
		} else {
			return [EDIT_DATASET_OPTION, RENAME_DATASET_OPTION];
		}
	}, [customDatasetName]);

	const savedCustomDatasetsNames = useMemo(() => {
		return (savedCustomDatasets ?? []).map((dataset) => dataset.customDatasetName);
	}, [savedCustomDatasets]);

	useEffect(() => {
		setMetricCalcAttr(ssiCompatibility);
	}, [ssiCompatibility]);

	useEffect(() => {
		if (showPreviewElementsTour) {
			let lSteps = deepClone(
				customerType === 'BASIC' ? BasicPreviewElementSteps : PreviewElementSteps
			);
			if (MOD_TMPT_LIST.includes(Number(selectedTemplate))) {
				lSteps = deepClone(
					customerType === 'BASIC' ? BasicPreviewElementStepsWOTime : PreviewElementStepsWOTime
				);
			}
			collapseAllAccordians();
			setTimeout(() => setRunTour(true), 500);
			setTourSteps(lSteps);
		} else {
			setRunTour(false);
		}
	}, [showPreviewElementsTour]);

	useEffect(() => {
		if (panelObjFromWhere === FILTER_LOWER) {
			setExpanded(hierarchy.map((folder) => folder.name));
		} else {
			setExpanded(usrSelection.length === 0 ? [TIME] : [usrSelection[0].folderName]);
		}
	}, [panelObjFromWhere]);

	const handleMenuEvents = (item) => {
		if (item.name === EDIT_DATASET) {
			setShowEditDataset(true);
		} else if (item.name === SAVE_DATASET) {
			setIsEditDatasetMode(false);
			setShowRenameDataset(true);
		} else if (item.name === RENAME_DATASET) {
			setIsEditDatasetMode(true);
			setShowRenameDataset(true);
		}
		setAnchorElement(null);
	};

	const calculateCount = (attributeType, currentIndex) => {
		if (panelObjFromWhere === FILTER_LOWER) {
			return;
		}
		if (attributeType && attributeType !== TIME) {
			const counters = selectedListCount;
			currentIndex === -1 ? counters[attributeType]++ : counters[attributeType]--;
			setSelectedListCount(counters);
		}
	};

	// This useEffect is required because when backroom columns are selected with daily grain, it will trigger
	// a incompatibility popup which will remove the backroom columns but the number of columns selected is not
	// updated. To update the number of columns selected in this particular case, this useEffect is needed.
	useEffect(() => {
		// Calculate the total number of columns selected (excluding time columns)
		const newItemListCount = selectedList.reduce((acc, item) => {
			// Skip all time columns since they won't contribute to the final (no. of selected columns/total columns)
			// total columns = all columns except time columns (dimensions, metrics and custom attributes)
			if (!TIME_BUSINESS_NAMES.includes(item.businessName)) {
				// Increment the count for the folderName or initialize it to 1
				acc[item.folderName] = (acc[item.folderName] || 0) + 1;
			}
			return acc;
		}, {});
		setSelectedListCount(newItemListCount);
	}, [selectedList]);

	/**
	 * For OMNI sales template,
	 * 1. if Future Vendor Pack Cost is selected, Future Effective Date should also be selected
	 * 2. if Future Effective Date is selected, Future Vendor Pack Cost should also be selected
	 */
	const handleOMNISalesBundleSelect = (value, selectedList) => {
		if (!OMNI_TMPT_LIST.includes(Number(selectedTemplate))) return;
		if (OMNI_BUNDLESELECT_MAP.has(value.technicalName)) {
			const toBeAddedNameList = OMNI_BUNDLESELECT_MAP.get(value.technicalName);
			toBeAddedNameList.forEach((toBeAddedName) => {
				if (selectedList.some((_o) => _o.technicalName === toBeAddedName)) return;
				const tmpData = templateData.filter(
					(item) => item.templateName === getTmplName(selectedTemplate)
				)[0];
				const toBeAddedData = tmpData.dimensions.find((_o) => _o.technicalName === toBeAddedName);
				const toBeAddedDataWithParents = { ...toBeAddedData, parent: 'dimensions' };
				selectedList.push(toBeAddedDataWithParents);
				calculateCount(toBeAddedDataWithParents.folderName, -1);
				dispatch(addPreviewColumn(previewData, toBeAddedDataWithParents.technicalName));
				determineIncompatibility(toBeAddedDataWithParents, -1);
			});
		}
	};

	const handleAddingSSIStoreTraitAttr = (value, selectedList) => {
		const isCustomDS = isCustomDataset(selectedTemplate);
		if (STR_TMPT_LIST.includes(Number(selectedTemplate)) || isCustomDS) {
			if (SSI_STORE_TRAIT_ATTRS.ATTR_SELECTION_TECHNICAL_NAME.includes(value.technicalName)) {
				const filters = deepClone(filterList);
				if (
					!filters.find((item) =>
						SSI_STORE_TRAIT_ATTRS.MENDATORY_FILTER_TECHNICAL_NAME.includes(item.technicalName)
					)
				) {
					const customDatasetReports = getSavedCustomDatasetWithAttributes(
						savedCustomDatasets,
						customDatasetDetails,
						customAttribute
					);
					let tmpData = [...templateData, ...customDatasetReports].filter(
						(item) =>
							(isCustomDataset(selectedTemplate) ? item.templateId : item.templateName) ===
							getTmplName(selectedTemplate)
					)[0];
					if (!tmpData) tmpData = selectedTemplate;
					const mendatoryFilters = tmpData.dimensions.filter((item) =>
						SSI_STORE_TRAIT_ATTRS.MENDATORY_FILTER_TECHNICAL_NAME.includes(item.technicalName)
					);
					mendatoryFilters.forEach((item) =>
						filters.push({
							...item,
							parent: 'dimensions',
							filter: { condition: '', value: [] }
						})
					);
					dispatch(setFilterList(filters));
				}
				const isTraitAttrSelected = selectedList.find((item) =>
					SSI_STORE_TRAIT_ATTRS.ATTR_SELECTION_TECHNICAL_NAME.includes(item.technicalName)
				);
				cbSetFilterTooltip({
					show: !isTraitAttrSelected,
					msg: (
						<Typography style={{ fontSize: '14px' }}>
							<pre style={{ textWrap: 'inherit', marginTop: '0px' }}>
								{SSI_STORE_TRAIT_ADDITION_TOOLTIP[0]} <b>{SSI_STORE_TRAIT_ADDITION_TOOLTIP[1]}</b>{' '}
								{SSI_STORE_TRAIT_ADDITION_TOOLTIP[2]}{' '}
							</pre>
							{SSI_STORE_TRAIT_ADDITION_TOOLTIP[3]}
						</Typography>
					)
				});
			} else {
				cbSetFilterTooltip({ show: false, msg: null });
			}
		}
	};

	const handleRemoveSSIStoreTraitAttr = (value, selectedList) => {
		const isCustomDS = isCustomDataset(selectedTemplate);
		if (STR_TMPT_LIST.includes(Number(selectedTemplate)) || isCustomDS) {
			if (SSI_STORE_TRAIT_ATTRS.ATTR_SELECTION_TECHNICAL_NAME.includes(value.technicalName)) {
				const isTraitAttrSelected = selectedList.find((item) =>
					SSI_STORE_TRAIT_ATTRS.ATTR_SELECTION_TECHNICAL_NAME.includes(item.technicalName)
				);
				cbSetFilterTooltip({
					show: !isTraitAttrSelected,
					msg: (
						<Typography style={{ fontSize: '14px' }}>{SSI_STORE_TRAIT_REMOVAL_TOOLTIP}</Typography>
					)
				});
			} else {
				cbSetFilterTooltip({ show: false, msg: null });
			}
		}
	};

	const handleListClick = (value, attributeType) => () => {
		/** User cannot select/deselect dimension as preview table column */
		if (CANNED_REPORT_LIST.includes(Number(selectedTemplate)) && attributeType === 'dimensions') {
			return;
		}
		/** User cannot deselect linked item dimension as preview table column */
		if (linkItemActivity !== '') {
			const techNmForLinkActivity = ['all_links_item_number', 'walmart_item_number'];
			if (techNmForLinkActivity.includes(value.technicalName)) {
				setSnackbar({
					open: true,
					msg: (
						<>
							<span>{LINK_ACTIVITY_DESELECTION_TOAST_REMOVE} </span>
							<span style={{ fontWeight: 700 }}>{LINK_ITEMS_NUM_BTN_TEXT} </span>
							<span>{LINK_ACTIVITY_DESELECTION_TOAST}</span>
						</>
					),
					type: 'success',
					guidedBtn: {
						name: LINK_ACTIVITY_DESELECTION_TOAST_BTN,
						handleGuideBtn: actionOnGuidedBtn
					}
				});
				return;
			}
		}

		/** USer cannot deselect business_area as preview table column for OMNI OTIF template */
		if (
			OTIF_TMPT_LIST.includes(Number(selectedTemplate)) &&
			value.technicalName === 'business_area'
		) {
			return;
		}

		const currentIndex = checked.findIndex((el) => {
			return el.businessName === value.businessName;
		});

		if (hasPivotedColumn(pivotOpts?.pivotColumn)) {
			/**
			 * On Pivoted condition, user cannot select columns more than the Limit
			 * If total count exceeds the limit, No further actions are allowed
			 */
			const newColumnCount =
				attributeType === 'measures'
					? totalColumCount + findAppliedTimeFilterCountForPivot(filterList)
					: totalColumCount + 1;
			let shouldNotAllowColumnSelection = newColumnCount > PIVOT_COLUMN_LIMIT && currentIndex < 0;
			if (
				pivotOpts?.pivotColumn === 'snap_shot_hour' &&
				ENTERPRISE_INVENTORY.includes(Number(selectedTemplateData.templateId))
			) {
				/**
				 * Special case:
				 * For EI template, if pivot is applied on snap_shot_hour, then the checkbox should not be unchecked
				 */
				shouldNotAllowColumnSelection = value?.technicalName === 'snap_shot_hour';
			}

			if (shouldNotAllowColumnSelection) {
				return;
			}
		}

		if (attributeType === PARENT_CUST_ATTR) {
			calculateCount(CUSTOM_ATTRIBUTE, currentIndex);
		}

		let selectedList = deepClone(checked);
		/**
		 * Selection and UnSelection
		 * If item share enabled, then
		 * 1) if Walmart item number || Catalog Item ID selected then
		 * 2) Item Access type should also get selected
		 */

		if (currentIndex === -1) {
			if (itemShareStatus.curr && ITEM_SHARE_SELECTION.includes(value.businessName)) {
				[mandatorySelection, value].forEach((el) => {
					const isPresent = selectedList.some((_o) => _o.businessName === el.businessName);
					if (!isPresent) {
						selectedList.push({ ...el });
						dispatch(addPreviewColumn(previewData, el.technicalName));
						calculateCount(value.folderName, -1);
					}
				});
			} else {
				/**
				 * For SSI template, if store trait related attributes are selected then
				 * 1. we need to add one required filter and
				 * 2. show a tooltip to users about the filter change
				 */
				handleAddingSSIStoreTraitAttr(value, selectedList);
				/**
				 * For OMNI sales template,
				 * 1. if Future Vendor Pack Cost is selected, Future Effective Date should also be selected
				 * 2. if Future Effective Date is selected, Future Vendor Pack Cost should also be selected
				 */
				handleOMNISalesBundleSelect(value, selectedList);

				selectedList.push({ ...value, parent: attributeType });
				dispatch(addPreviewColumn(previewData, value.technicalName));
				calculateCount(value.folderName, currentIndex);
				/**
				 * If user selects Variant attributes
				 *  - Turn on Item share (Supplier and Catman)
				 *  - Add 'WMT Item Number' by default.
				 *
				 */
				const isVariantPresent = isVariantAttrInTheList(selectedList);
				const enableItemShare =
					isVariantPresent &&
					!itemShareStatus.curr &&
					customerType === CHARTER &&
					userPersona != PERSONA.MERCHANT;
				if (enableItemShare) {
					dispatch(saveItemShareStatus({ curr: true }));
				}
				if (isVariantPresent) {
					const isWMTItemNumberExist = selectedList?.some(
						(item) => item?.businessName === DEFAULT_VARIANT_SELECTION
					);
					const wmtItemNumber = selectedTemplateData?.dimensions?.find(
						(dim) => dim?.businessName === DEFAULT_VARIANT_SELECTION
					);
					// If Walmart item number is not already a part of selected list and if it is present, then add it
					if (!isWMTItemNumberExist && wmtItemNumber) {
						selectedList.push({ ...wmtItemNumber, parent: attributeType });
						dispatch(addPreviewColumn(previewData, wmtItemNumber.technicalName));
						calculateCount(wmtItemNumber.folderName, currentIndex);
					}
					const isItemAccessTypeExist = selectedList?.some(
						(item) => item?.businessName === ITEM_ACCESS_TYPE
					);
					const itemAccessType = selectedTemplateData?.dimensions?.find(
						(dim) => dim?.businessName === ITEM_ACCESS_TYPE
					);
					// If Item Access type is not selected and if Item Access type is available in the list of dimensions, then add it
					if (!isItemAccessTypeExist && itemAccessType) {
						selectedList.push({ ...itemAccessType, parent: attributeType });
						dispatch(addPreviewColumn(previewData, itemAccessType.technicalName));
					}
				}
			}
			selectedList = reorderSelectedList(selectedList);
		} else {
			if (itemShareStatus.curr && ITEM_SHARE_SELECTION.includes(value.businessName)) {
				const itemShareSpecificAttrLen = selectedList.filter((el) => {
					return ITEM_SHARE_SELECTION.includes(el.businessName);
				}).length;

				if (itemShareSpecificAttrLen === 1) {
					for (let index = 0; index < selectedList.length; index++) {
						if (
							[mandatorySelection.businessName, value.businessName].includes(
								selectedList[index].businessName
							)
						) {
							const { technicalName, table, parent } = selectedList[index];
							dispatch(removePreviewColumn(previewData, technicalName, parent, table));
							selectedList.splice(index, 1);
							index--;
							calculateCount(value.folderName, 1);
						}
					}
				} else {
					selectedList.splice(currentIndex, 1);
					const o = checked[currentIndex];
					const { technicalName, table, parent } = o;
					dispatch(removePreviewColumn(previewData, technicalName, parent, table));
					calculateCount(value.folderName, 1);
				}
			} else {
				selectedList.splice(currentIndex, 1);
				/**
				 * For SSI template, if all store trait related attributes are de-selected then
				 * we need to move the required filter from required section to optional section
				 */
				handleRemoveSSIStoreTraitAttr(value, selectedList);
				const o = checked[currentIndex];
				const { technicalName, table, parent } = o;
				dispatch(removePreviewColumn(previewData, technicalName, parent, table));
				calculateCount(value.folderName, 1);

				/**
				 * [SSI - Metric Selection] - if removed from table, then will also need to be removed from filter
				 */
				if (attributeType === 'measures') {
					const _list = filterList.filter((item) => item.businessName !== value.businessName);
					dispatch(setFilterList(_list));
				}
			}
		}
		setTotalSelected(selectedList?.length);
		setChecked(deepClone(selectedList));
		dispatch(setSelectedList(deepClone(selectedList)));

		/**
		 * Below iterations are to determine incompatibility
		 */
		determineIncompatibility(value, currentIndex);
	};

	//DSIDVL-42229: the columns displayed on metadata panel and excel sheet should follow this order: time -> dimensions -> metrics -> customAttr
	const reorderSelectedList = (unorderedSelectedList) => {
		const times = [];
		const dimensions = [];
		const measures = [];
		const customAttrs = [];
		//in case MTS parent not included
		const others = [];
		for (let item of unorderedSelectedList) {
			if (isCalFamily(item)) {
				times.push(item);
			} else if (item.parent === ATTRIBS_LOWERCASE.dimensions) {
				dimensions.push(item);
			} else if (item.parent === ATTRIBS_LOWERCASE.measures) {
				measures.push(item);
			} else if (item.parent === ATTRIBS_LOWERCASE.customAttribute) {
				customAttrs.push(item);
			} else {
				others.push(item);
			}
		}
		return [...times, ...others, ...dimensions, ...measures, ...customAttrs];
	};

	/** add incompatibility check item when currentIndex === -1, which means value is newly added by list click.
	 * remove incompatibility check item when currentIndex != -1
	 */
	const determineIncompatibility = (value, currentIndex) => {
		const _metricCal = computeIncompatibilityObject(
			value,
			currentIndex,
			selectedTemplate,
			metricCalcAttr
		);
		setMetricCalcAttr(_metricCal);
		cbSSIComptability(_metricCal);
	};

	const getSearchValues = (searchText) => {
		setSearchQuery(searchText);

		if (searchText.length === 0) {
			handleAccordianExpansion([TIME], true);
			setFolders(hierarchy);
			return;
		}

		const copy = deepClone(folders);
		const tobeExpanded = [];
		hierarchy.map((folder) => {
			const periods = folder.periods ? deepClone(folder.periods) : undefined;
			periods?.forEach((time) => {
				const searched = time.subAttributes.filter((item) => {
					if (item.businessName.toLowerCase().includes(searchText.toLowerCase())) {
						return item;
					}
				});
				time.subAttributes = searched;
			});
			const dim = folder.dimensions;
			const updatedDimensions = dim?.filter((item) => {
				if (
					item.businessName.toLowerCase().includes(searchText.toLowerCase()) ||
					item?.dssName?.toLowerCase().includes(searchText.toLowerCase())
				) {
					return item;
				}
			});
			const updatedDisabledDim = folder?.disabledDim?.filter((item) => {
				if (
					item.businessName.toLowerCase().includes(searchText.toLowerCase()) ||
					item?.dssName?.toLowerCase().includes(searchText.toLowerCase())
				) {
					return item;
				}
			});
			const updatedMeasures = folder?.measures?.filter(
				(item) =>
					item.businessName.toLowerCase().includes(searchText.toLowerCase()) ||
					item?.dssName?.toLowerCase().includes(searchText.toLowerCase())
			);
			const updatedDisabledMes = folder?.disabledMsr?.filter((item) => {
				if (
					item.businessName.toLowerCase().includes(searchText.toLowerCase()) ||
					item?.dssName?.toLowerCase().includes(searchText.toLowerCase())
				) {
					return item;
				}
			});
			const updatedCustomAttribute = folder?.customAttribute?.filter((item) => {
				if (
					item.businessName.toLowerCase().includes(searchText.toLowerCase()) ||
					item?.dssName?.toLowerCase().includes(searchText.toLowerCase())
				) {
					return item;
				}
			});
			copy.filter((item) => item.name === folder.name)[0].periods = periods;
			copy.filter((item) => item.name === folder.name)[0].dimensions = updatedDimensions;
			copy.filter((item) => item.name === folder.name)[0].disabledDim = updatedDisabledDim;
			copy.filter((item) => item.name === folder.name)[0].measures = updatedMeasures;
			copy.filter((item) => item.name === folder.name)[0].disabledMsr = updatedDisabledMes;
			copy.filter((item) => item.name === folder.name)[0].customAttribute = updatedCustomAttribute;
			if (
				periods?.reduce((sum, time) => {
					return sum + time.subAttributes?.length;
				}, 0) > 0 ||
				updatedDimensions?.length > 0 ||
				updatedDisabledDim?.length > 0 ||
				updatedDisabledMes?.length > 0 ||
				updatedMeasures?.length > 0 ||
				updatedCustomAttribute?.length > 0
			) {
				tobeExpanded.push(folder.name);
			}
		});

		handleAccordianExpansion(tobeExpanded, true);
		setFolders(copy);
		setClear(false);
	};

	const handleAccordianExpansion = (names, isSearchOn = false) => {
		if (isSearchOn) {
			setExpanded(names);
			return;
		}

		if (expanded.includes(names[0])) {
			const temp = deepClone(expanded);
			temp.splice(
				temp.findIndex((name) => name === names[0]),
				1
			);
			setExpanded(temp);
			return;
		}
		setExpanded(names);
	};

	const handleClear = () => {
		const savedCustomDatasetWithAttributes = getSavedCustomDatasetWithAttributes(
			savedCustomDatasets,
			customDatasetDetails,
			customAttribute
		);
		const allData = [...templateData, ...cannedReportData, ...savedCustomDatasetWithAttributes];
		let result;
		if (isCustomDataset(selectedTemplate)) {
			result = allData.filter(
				(item) => (item.customDatasetId || item.templateId) === selectedTemplate
			);
		} else {
			result = allData.filter((item) => item.templateName === getTmplName(selectedTemplate));
		}

		let defaultFilterSel = getDfltFilter(result);
		let sbuList = [];
		let modList = [];
		const SBUDfltCondition = FILTER_CONDITION_LABELS.IS_EQUAL_TO;
		/**
		 * | MERCHANT with limited access
		 */
		if (userPersona === 'MERCHANT') {
			const SBUdimension = result[0].dimensions.filter((dim) =>
				sbuDBTechNames.includes(dim.dbtechnicalName)
			);

			const dfltFiltersOnDimensions = [];
			SBUdimension.map((dim) => {
				dfltFiltersOnDimensions.push({
					dimension: dim,
					condition: SBUDfltCondition,
					value: sbuDepartments.map((dept) => dept.deptNum)
				});
			});
			sbuList = getDfltFilter(result, dfltFiltersOnDimensions, false);
			sbuList.map((filter, index) => {
				if (sbuDBTechNames.includes(filter.dbtechnicalName)) {
					const field = build(sbuList[index], selectedView, userPersona);
					sbuList[index] = { ...sbuList[index], field };
				}
			});
		}

		// TODO: need to refactor after Mid May release
		let list = [];
		if (MOD_TMPT_LIST.includes(Number(selectedTemplate))) {
			const toBeAdded = result[0].dimensions.filter(
				(item) => item.technicalName === 'store_item_valid_ind'
			)[0];
			list = [{ ...toBeAdded, parent: 'dimensions' }];

			const dimToBeFiltered = result[0].dimensions.filter(
				(dim) => dim.technicalName === 'store_item_valid_ind'
			);
			const dfltFiltersOnDimensions = [];
			dimToBeFiltered.map((dim) => {
				dfltFiltersOnDimensions.push({
					dimension: dim,
					condition: SBUDfltCondition,
					value: ['1']
				});
			});
			modList = getDfltFilter(result, dfltFiltersOnDimensions, false);

			modList.map((filter, index) => {
				if (filter.technicalName === 'store_item_valid_ind') {
					const field = build(modList[index], selectedView, userPersona);
					modList[index] = { ...modList[index], field };
				}
			});
		}

		defaultFilterSel = [...defaultFilterSel, ...sbuList, ...modList];

		/**
		 * OMNI OTIF template should have 'business_area attribute selected as a column by default'
		 */
		if (OTIF_TMPT_LIST.includes(Number(selectedTemplate))) {
			const toBeAdded = result[0].dimensions.filter(
				(item) => item.technicalName === 'business_area'
			)[0];
			list = [{ ...toBeAdded, parent: 'dimensions' }];
		}

		const selCounts = {};
		const folderNamesOfAddedAttr = list.map((item) => item.folderName);
		hierarchy.forEach((folder) => {
			if (folder.name !== TIME) {
				selCounts[folder.name] = 0;
				if (folderNamesOfAddedAttr.includes(folder.name)) {
					selCounts[folder.name]++;
				}
			}
		});

		cbSSIComptability(INITIAL_SSI_COMPATIBILITY);
		setClear(true);
		setChecked(list);
		setTotalSelected(list.length);
		setSelectedListCount(selCounts);
		dispatch(setSelectedList(list));
		dispatch(clearPreview([]));
		dispatch(resetPivotOptions());
		dispatch(setFilterList(defaultFilterSel));
		dispatch(setPrevFilterList(defaultFilterSel));
	};

	useEffect(() => {
		if (selectedTemplate !== null && selectedTemplate !== undefined) {
			const isCannedReport = SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate));
			const copiedList = deepClone(selectedList);
			const savedCustomDatasetWithAttributes = getSavedCustomDatasetWithAttributes(
				savedCustomDatasets,
				customDatasetDetails,
				customAttribute
			);
			const allData = [...templateData, ...cannedReportData, ...savedCustomDatasetWithAttributes];
			let result;
			if (isCustomDataset(selectedTemplate)) {
				result = allData.filter(
					(item) => (item.customDatasetId || item.templateId) === selectedTemplate
				);
			} else {
				result = allData.filter((item) => item.templateName === getTmplName(selectedTemplate));
			}
			/**
			 * OMNI OTIF template should have 'business_area attribute selected as a column by default'
			 */
			if (OTIF_TMPT_LIST.includes(Number(selectedTemplate))) {
				const index = selectedList.findIndex((el) => el.technicalName === 'business_area');
				if (index === -1) {
					const value = result[0]?.dimensions.filter(
						(el) => el.technicalName === 'business_area'
					)[0];

					copiedList.push({
						...value,
						parent: 'dimensions'
					});
					calculateCount('dimensions', index);
					dispatch(setSelectedList(copiedList));
					const filters = deepClone(filterList);
					filters.push({
						...value,
						parent: 'dimensions',
						filter: { condition: '', value: [] }
					});
					dispatch(setFilterList(filters));
				}
			}
			setSelectedTemplateData(result[0]);

			const hierarchyFolders = createFolders(
				result,
				customAttribute,
				isCannedReport,
				isStudent,
				disableAttribute
			);
			setFolders(hierarchyFolders);
			dispatch(setHierarchy(hierarchyFolders));

			const counters = {};
			hierarchyFolders.forEach((folder) => {
				if (folder.name !== TIME) {
					counters[folder.name] = 0;
				}
			});
			copiedList.forEach((el) => {
				if (el.folderName !== TIME) {
					if (el.parent === PARENT_CUST_ATTR) {
						counters[CUSTOM_ATTRIBUTE]++;
					} else if (el.folderName) {
						counters[el.folderName]++;
					}
				}
			});
			if (panelObjFromWhere !== FILTER_LOWER) {
				setSelectedListCount(counters);
				setTotalAttributes(
					Object.keys(hierarchyFolders).reduce((sum, cur) => {
						const dimLength = hierarchyFolders[cur].dimensions?.length || 0;
						const mesLength = hierarchyFolders[cur].measures?.length || 0;
						const custAttrLength = hierarchyFolders[cur].customAttribute?.length || 0;
						return sum + dimLength + mesLength + custAttrLength;
					}, 0)
				);
			}
		}
	}, [selectedTemplate, templateData, cannedReportData]);

	useEffect(() => {
		setChecked(selectedList);
	}, [selectedList]);

	useEffect(() => {
		if (expanded.includes(TIME)) {
			setShowProTip(true);
		} else {
			setShowProTip(false);
		}
	}, [expanded]);

	useEffect(() => {
		/**
		 * Custom dataset Tour last step, click on "More"
		 */
		if (CDTourStepIndex === 5) {
			setTimeout(() => moreRef.current?.click(), 100);
		}
	}, [CDTourStepIndex]);

	function collapseAllAccordians() {
		const toBeClosed = expanded;
		handleAccordianExpansion(toBeClosed);
	}

	function handleTourCallback(data) {
		function expandDimFolder() {
			for (let i = 0; hierarchy?.length; i++) {
				if (hierarchy[i].dimensions?.length > 0) {
					handleAccordianExpansion([hierarchy[i].name]);

					break;
				}
			}
		}
		const { action, index, type } = data;
		if (action === 'skip' || type === 'tour:end') {
			// Update flag in Local storage & Store to stop showing Tour guides
			localStorage.setItem('PreviewElementTourSkip', true);
			dispatch(
				setStartTourAction({
					isFirstTimeUser: false,
					isTourFromHelp: false,
					showTourStarter: false,
					showPreviewElementsTour: false
				})
			);
		}
		if (MOD_TMPT_LIST.includes(Number(selectedTemplate)) && type === 'tour:start') {
			collapseAllAccordians();
			expandDimFolder();
		}
		if (type === 'step:after') {
			if (index === 0) {
				expandDimFolder();
			}
		}
	}

	// Finds the total no. of Table columns, to decide if user can apply the Pivot
	const totalColumCount = useMemo(
		() =>
			hasPivotedColumn(pivotOpts?.pivotColumn)
				? calculateTotalColumnCount(selectedList, filterList, pivotOpts.isTimeAcross)
				: 0,
		[selectedList, filterList, pivotOpts?.pivotColumn]
	);

	const totalMeasureCount = useMemo(
		() =>
			selectedList.reduce((measureCount, item) => {
				if (item?.parent === ATTRIBS_LOWERCASE.measures) {
					return measureCount + 1;
				}
			}, 0),
		[selectedList]
	);

	const timeScale = useMemo(() => findAppliedTimeFilterCountForPivot(filterList), [filterList]);

	const GenerateList = (val, id, attributeType) => {
		const index = checked.findIndex((el) => el.businessName === val.businessName);
		let isChecked = index !== -1;
		let disabled = false;
		let checkboxDisabled = false || getCount('selected') >= SELECTED_COLUMN_LIMIT;
		/**
		 * Create unique list of business names from selected list
		 * and filterlist. If count is >= 5 then don't disable
		 * else disable.
		 *
		 */
		if (attributeType === PARENT_CUST_ATTR) {
			const selCustAttrList = [];
			const filCustAttrList = [];

			selectedList.forEach((el) => {
				if (el.parent === PARENT_CUST_ATTR) {
					selCustAttrList.push(el.businessName);
				}
			});

			filterList.forEach((el) => {
				if (el.parent === PARENT_CUST_ATTR && el.field !== undefined) {
					filCustAttrList.push(el.businessName);
				}
			});

			const uniqueCustSel = [...new Set([...selCustAttrList, ...filCustAttrList])];
			if (uniqueCustSel.length === 5 && !uniqueCustSel.includes(val.businessName)) {
				disabled = true;
			}
		}

		/**
		 * For SSI template,
		 * if allLinkRollUp, attribute unit cost amount should be disabled
		 */
		if (
			ALL_LINK_ITEM_LIST.includes(Number(selectedTemplate)) &&
			linkItemActivity === 'allLinkRollUp'
		) {
			disabled = ['manufacturing_company_id', 'unit_cost_amount'].includes(val.technicalName)
				? true
				: false;
		}

		/** User cannot deselect linked item dimension as preview table column */
		if (linkItemActivity !== '') {
			const techNmForLinkActivity = ['all_links_item_number', 'walmart_item_number'];
			if (techNmForLinkActivity.includes(val.technicalName)) {
				checkboxDisabled = true;
			}
		}

		const pivotedColumn = hasPivotedColumn(pivotOpts?.pivotColumn);
		if (
			pivotedColumn &&
			val?.technicalName === 'snap_shot_hour' &&
			ENTERPRISE_INVENTORY.includes(Number(selectedTemplateData.templateId))
		) {
			/**
			 * If Pivot is applied on attribute 'Hour' of Hourly Store Inventory template,
			 * the checkbox should be checked and never able to uncheck by user
			 */
			isChecked = true;
			checkboxDisabled = true;
		}

		// While on Pivot, if user has reached Max column limit, then all other the checkbox should be disabled
		if (pivotedColumn && !isChecked) {
			let potentialNewColumnCount;
			if (attributeType === 'measures') {
				if (pivotOpts.isTimeAcross && totalMeasureCount > 0) {
					potentialNewColumnCount = totalColumCount;
				} else {
					potentialNewColumnCount = totalColumCount + timeScale;
				}
			} else {
				potentialNewColumnCount = totalColumCount + 1;
			}
			checkboxDisabled = potentialNewColumnCount > PIVOT_COLUMN_LIMIT;
		}

		if (ECOMM_INSTOCK_LIST.includes(Number(selectedTemplate))) {
			const valTechName = val?.technicalName;
			const isPercentageMeasure =
				valTechName && ECOMM_INSTOCK_PERCENTAGE_MEASURES.includes(valTechName);
			const isFcMeasure = valTechName && ECOMM_INSTOCK_FC_MEASURES.includes(valTechName);

			if (isPercentageMeasure || isFcMeasure) {
				const conflictingMeasures = isPercentageMeasure
					? ECOMM_INSTOCK_FC_MEASURES
					: ECOMM_INSTOCK_PERCENTAGE_MEASURES;

				checkboxDisabled ||= selectedList.some((item) =>
					conflictingMeasures.includes(item.technicalName)
				);
			}
		}
		const checkStudent = isStudent && val?.isDisabledForStudent;
		let disableAttributeForUser =
			(disableAttribute && (val?.isDisabled || checkboxDisabled)) || checkStudent;

		return (
			<PreviewListItemContext.Provider
				value={{
					cbHandleListClick: handleListClick(val, attributeType)
				}}
				key={id}>
				<AttrList
					key={id}
					item={val}
					checked={isChecked}
					parent={attributeType}
					disabled={disabled}
					paddingLeft={panelObjFromWhere !== FILTER_LOWER ? 0 : 26}
					showCheckbox={panelObjFromWhere !== FILTER_LOWER}
					checkboxDisabled={checkboxDisabled}
					disableAttributeForUser={disableAttributeForUser}
				/>
			</PreviewListItemContext.Provider>
		);
	};

	const listCheck = () => {
		return folders.reduce((sum, cur) => {
			const periods =
				cur.periods?.reduce((sum, time) => {
					return sum + time.subAttributes?.length;
				}, 0) || 0;
			const dims = cur.dimensions?.length || 0;
			const disabledDims = cur.disabledDim?.length || 0;
			const measures = cur.measures?.length || 0;
			const disabledMes = cur.disabledMsr?.length || 0;
			const custAttr = cur.customAttribute?.length || 0;
			return sum + periods + dims + disabledDims + measures + disabledMes + custAttr;
		}, 0);
	};

	const getSubHeader = (item) => {
		if (item.name === CUSTOM_ATTRIBUTE) {
			if (disableCustomAttribute) {
				return (
					<Box className={classes.customContainer}>
						<Typography className={classes.customText}>{CUSTOM_ATTRIBUTE}</Typography>
						<Typography className={classes.customCharterText}>{'Charter only'}</Typography>
					</Box>
				);
			}
			const maxSel = '(max 5)';
			return (
				<>
					{CUSTOM_ATTRIBUTE} <span style={{ fontWeight: 400, color: '#6D6E71' }}>{maxSel}</span>
				</>
			);
		}
		return item.name;
	};

	if (selectedTemplateData === null || selectedTemplateData === undefined) {
		return null;
	}

	const getCount = (countType) => {
		if (countType === 'selected') {
			return Object.keys(selectedListCount).reduce(
				(sum, cur) => sum + (selectedListCount[cur] || 0),
				0
			);
		}
	};

	const shouldExpand = (folder) => {
		return (
			expanded.includes(folder.name) &&
			(folder.periods?.reduce((sum, time) => {
				return sum + time.subAttributes?.length;
			}, 0) > 0 ||
				folder.dimensions?.length > 0 ||
				folder.measures?.length > 0 ||
				folder.disabledDim?.length > 0 ||
				folder.disabledMsr?.length > 0 ||
				folder.customAttribute?.length > 0)
		);
	};

	const hideSnackbar = () => {
		setSnackbar({ open: false, msg: '', guidedBtn: false });
	};

	/**
	 * Pinned Data
	 * Transforms pinned attribute into an object with dimensions and measures
	 */
	const pinnedData = transformPinnedAttribute(
		pinnedAttribute[selectedTemplate],
		selectedTemplateData,
		searchQuery
	);
	const pinnedAttributesCount = pinnedData?.dimensions?.length + pinnedData?.measures?.length;

	const isDuplicateName = (datasetName) => {
		return savedCustomDatasetsNames.some(
			(name) => name.toLowerCase().trim() === datasetName.toLowerCase().trim()
		);
	};

	const unsavedDatasetLabel = () => {
		return (
			<Box display="flex" alignItems="center">
				<Box style={{ margin: '8px 0px 0 0' }}>
					<img style={{ width: '24px' }} src={datasetIcon} alt="dataset-icon"></img>
				</Box>
				<InputLabel className={classes.unsaved}>{UNSAVED_DATASET}</InputLabel>
				<Tooltip arrow title={DATASET_TOOLTIP} classes={{ tooltip: classes.tooltip }}>
					<IconButton aria-label="unsaved-info-icon">
						<InfoOutlinedIcon className={classes.infoIconNormal} />
					</IconButton>
				</Tooltip>
			</Box>
		);
	};

	const isCustomDS = isCustomDataset(selectedTemplateData.templateId);
	// We need a different max-height for Preview elements in the case of custom dataset because there are extra elements in the UI.
	// To compensate for those extra elements, we add 50px to the max height than what we already had
	const panelClass = isCustomDS ? classes.customDatasetPanel : classes.panel;

	return (
		<Box className={classes.relative}>
			<Tour steps={tourSteps} run={runTour} cbHandleJoyride={handleTourCallback} />
			<Box>
				<Box
					aria-controls="template-attribute-header"
					className={classes.titleContainer}
					id="template-attribute-header"
					style={{ width: drawerWidth }}>
					<Typography className={classes.titleFont}>
						{panelObjIcon}
						<span>{panelObjHeader}</span>
						{panelObjFromWhere !== FILTER_LOWER && (
							<IconButton
								onClick={() => cbSetShowPreviewElement(panelObjFromWhere)}
								className={`${classes.closeIcon} ${classes.floatRight}`}
								aria-label="Close">
								<CloseIcon style={{ color: '#6D6E71' }} />
							</IconButton>
						)}
					</Typography>
					<Divider />
					{isCustomDS && (
						<>
							<Typography className={classes.titleFont}>
								<Box
									id="custom-dataset-name"
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										width: '100%',
										margin: '0 10px'
									}}>
									<span>{customDatasetName || unsavedDatasetLabel()}</span>
									<IconButton
										ref={moreRef}
										id="metadata-more"
										aria-label="metadata-more"
										size="small"
										className={classes.crossButton}
										onClick={(e) => {
											e.stopPropagation();
											setAnchorElement(e.currentTarget);
										}}>
										{' '}
										<MoreHorizIcon fontSize="small" />{' '}
									</IconButton>
								</Box>
							</Typography>
							<Divider />
							<MenuItemsList
								optionsList={CUSTOM_TEMPLATE_OPTIONS_LIST}
								anchorEl={anchorElement}
								handleEvents={handleMenuEvents}
								setAnchorEl={setAnchorElement}
							/>
						</>
					)}
					<PreviewSearch cbPreviewSearch={getSearchValues} clear={clear} />
				</Box>
				<Box className={panelClass} style={{ width: drawerWidth }}>
					{listCheck() === 0 && (
						<Box>
							<ProTipComponent searchKeyword={searchQuery} />
							<Box className={classes.noMatchPanel}>
								<WarningIcon alt="warning-icon" height="12px" style={{ paddingLeft: '16px' }} />
								<Typography className={classes.noMatch}>{NO_MATCH}</Typography>
							</Box>
						</Box>
					)}
					{getCount('selected') === SELECTED_COLUMN_LIMIT && (
						<Box className={classes.noMatchPanel}>
							<WarningIcon alt="warning-icon" height="12px" style={{ paddingLeft: '16px' }} />
							<Typography className={classes.noMatch}>{MAX_SELECTED_COLUMNS}</Typography>
						</Box>
					)}
					{/* Pinned Data */}
					{pinnedAttributesCount > 0 && enablePinnedAttribute && (
						<PinnedDataFolder
							searchQuery={searchQuery}
							pinnedAttributesCount={pinnedAttributesCount}
							pinnedAttribute={pinnedAttribute[selectedTemplate]}>
							<StyledAccordianDetail>
								{pinnedData?.dimensions?.length > 0 && (
									<>
										<span className={classes.attrTypeText}>{DIMENSION}</span>
										{pinnedData?.dimensions.map((dim, id) => {
											return GenerateList(dim, id, 'dimensions');
										})}
									</>
								)}
								{pinnedData?.measures?.length > 0 && (
									<>
										<span className={classes.attrTypeText}>{MEASURES}</span>
										{pinnedData?.measures.map((meas, id) => {
											return GenerateList(meas, id, 'measures');
										})}
									</>
								)}
							</StyledAccordianDetail>
						</PinnedDataFolder>
					)}

					{folders.map((item, index) => {
						const dimensions = item.dimensions;
						let measures = item.measures;
						const disabledDim = item.disabledDim;
						const disabledMsr = item.disabledMsr;
						if (
							panelObjFromWhere === FILTER_LOWER &&
							CANNED_REPORT_LIST.includes(Number(selectedTemplate))
						) {
							measures = [];
						}
						// For Hourly Store Inventory, custom attribute should not be displayed in filter
						if (
							ENTERPRISE_INVENTORY.includes(Number(selectedTemplateData.templateId)) &&
							item.name === CUSTOM_ATTRIBUTE
						) {
							return null;
						}

						if (
							[...PURCHASE_ORDER_LIST, ...FUTURE_VALID_LIST].includes(
								Number(selectedTemplateData.templateId)
							) &&
							item.name === CUSTOM_ATTRIBUTE
						) {
							return null;
						}

						return (
							<>
								{item.name === TIME ? (
									<TimeFrame
										key={index}
										selectedTemplateData={item.periods}
										shouldExpand={() => shouldExpand(item)}
										templateId={selectedTemplate}
										id={`timeframe-${index}`}
										showCheckbox={panelObjFromWhere !== FILTER_LOWER}
										cbHandleExpansion={handleAccordianExpansion}
										mtsSubAttr={mtsSubAttr}
									/>
								) : dimensions?.length === 0 &&
								  measures?.length === 0 &&
								  disabledDim?.length === 0 &&
								  disabledMsr?.length === 0 ? null : (
									<Accordion
										id={`accordian-${index}`}
										key={index}
										className={classes.accordian}
										expanded={shouldExpand(item)}
										onChange={() => handleAccordianExpansion([item.name])}
										elevation={0}
										TransitionProps={{ unmountOnExit: true }} // Render the accordion details when expanded
										square={true}>
										<StyledAccordionSummary aria-controls="panel1a-content" id="panel1a-header">
											{!shouldExpand(item) && <ArrowRightIcon sx={{ fontSize: 24 }} />}
											{shouldExpand(item) && <ArrowDropDownIcon sx={{ fontSize: 24 }} />}
											<Typography className={classes.listItemText}>
												<span className={classes.subHeaderText}>{getSubHeader(item)}</span>
												{panelObjFromWhere !== FILTER_LOWER && (
													<span className={`${classes.subHeaderCount} ${classes.floatRight}`}>
														{`${selectedListCount[item.name] || 0} / ${
															item.name === CUSTOM_ATTRIBUTE
																? item[PARENT_CUST_ATTR].length
																: dimensions?.length + measures?.length
														}`}
													</span>
												)}
											</Typography>
										</StyledAccordionSummary>
										{item.name === CUSTOM_ATTRIBUTE ? (
											<StyledAccordianDetail>
												{item.customAttribute.length > 0 &&
													item.customAttribute.map((val, id) => {
														return GenerateList(val, id, PARENT_CUST_ATTR);
													})}
											</StyledAccordianDetail>
										) : (
											<StyledAccordianDetail>
												{(dimensions?.length > 0 || disabledDim?.length > 0) && (
													<span className={classes.attrTypeText}>{DIMENSION}</span>
												)}
												{dimensions?.length > 0 && (
													<>
														{dimensions.map((val, id) => {
															return GenerateList(val, id, 'dimensions');
														})}
													</>
												)}
												{item.disabledDim?.length > 0 && (
													<>
														<span className={classes.attrTypeText}>
															{CHARTER_ONLY_DATA}
															<LockOutlinedIcon style={{ height: '14px' }} />
														</span>
														{item.disabledDim.map((val, id) => {
															return GenerateList(val, id, 'dimensions');
														})}
													</>
												)}
												{(measures?.length > 0 || disabledMsr?.length > 0) && (
													<span className={classes.attrTypeText}>{MEASURES}</span>
												)}
												{measures?.length > 0 && (
													<>
														{measures.map((val, id) => {
															return GenerateList(val, id, 'measures');
														})}
													</>
												)}
												{item.disabledMsr?.length > 0 && (
													<>
														<span className={classes.attrTypeText}>
															{CHARTER_ONLY_DATA}
															<LockOutlinedIcon style={{ height: '14px' }} />
														</span>
														{item.disabledMsr.map((val, id) => {
															return GenerateList(val, id, 'measures');
														})}
													</>
												)}
											</StyledAccordianDetail>
										)}
									</Accordion>
								)}
							</>
						);
					})}

					{panelObjFromWhere !== FILTER_LOWER && (
						<Box
							className={classNames(
								classes.footer,
								showProTip ? classes.proTipFooterHeight : classes.defaultFooterHeight
							)}
							style={{ width: drawerWidth }}>
							{showProTip && (
								<Box
									className={classes.proTipContainer}
									display="flex"
									alignItems="center"
									flexDirection="column"
									justifyContent="center"
									alignContent="center">
									<Box display="flex" flexDirection="row" alignItems="center">
										<Box>
											<InfoOutlinedIcon
												style={{ color: '#6D6E71', marginLeft: 10, marginRight: 10 }}
												fontSize="small"
											/>
										</Box>
										<Box className={classes.proTipText}>
											{LY_PROTIP_TEXT}{' '}
											<Link
												href={`${getBaseUrl()}${
													isBasic ? PROTIP_LEARN_MORE_BASIC : PROTIP_LEARN_MORE
												}`}
												target="_blank">
												{LEARN_MORE}
											</Link>
										</Box>
									</Box>
								</Box>
							)}
							<Box className={classes.footerText}>
								<Box className={`${classes.footerCount} ${classes.footerText}`}>
									{`${getCount('selected') || 0}  / ${totalAttributes}
							selected`}
								</Box>
								<Button
									aria-label="Clear All"
									id="clear-all"
									size="small"
									className={classes.button}
									onClick={handleClear}>
									<InputLabel className={classes.buttonLabel}>{CLEAR_ALL}</InputLabel>
								</Button>
							</Box>
						</Box>
					)}
				</Box>
			</Box>
			{showRenameDataset && (
				<SaveDatasetModel
					isEditMode={isEditDatasetMode}
					previousName={customDatasetName}
					isDuplicateName={isDuplicateName}
					onDontSave={() => setShowRenameDataset(false)}
					open={showRenameDataset}
					onClose={() => setShowRenameDataset(false)}
					onSaveModal={(newName) => {
						if (!isEditDatasetMode && !customDatasetName) {
							const matchingDataset = savedCustomDatasets.find(
								(ele) => ele.customDatasetName === newName
							);
							if (matchingDataset) console.log('Dataset with same name already present');
							else {
								const tables = [];
								const { dimensions, measures } = selectedTemplateData;
								const mergedDimensionsAndMeasures = [...measures, ...dimensions];
								mergedDimensionsAndMeasures.forEach((item) => {
									if (!tables.includes(item.folderName)) tables.push(item.folderName);
								});
								const requestBody = {
									customDatasetName: newName,
									customDatasetDesc: '',
									tables
								};
								if (tables.length) dispatch(saveCustomDataset(requestBody));
								trackEventInfo({
									type: EVENTS.CLICK,
									actionOn: ACTION_ON.CUSTOM_DATASET_SAVED,
									location: PAGE_ID.PREVIEW
								});
							}
						} else {
							const existingDataset = savedCustomDatasets.find(
								(ele) => ele.customDatasetName === customDatasetName
							);
							if (!existingDataset) {
								console.error(`No custom dataset found with name: ${customDatasetName}`);
								return;
							}
							let newDataset = deepClone(existingDataset);
							newDataset['customDatasetName'] = newName;
							//Note: For now, before we update the cardTitle using backend returned data, the customDatasetName will be new name and cardTitle will be oldName
							dispatch(updateCustomDataset(newDataset));
							trackEventInfo({
								type: EVENTS.CLICK,
								actionOn: ACTION_ON.CUSTOM_DATASET_RENAME,
								location: PAGE_ID.PREVIEW
							});
						}
						setShowRenameDataset(false);
					}}
				/>
			)}
			{showEditDataset && (
				<CustomTemplateMain
					templateData={templateData}
					isEditMode={true}
					onModalClose={() => setShowEditDataset(false)}
					selectedCustomDataset={selectedCustomDataset}
				/>
			)}
			{/* Pivot - Column or Row selection pop-up */}
			<TimeRangeSelection />
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				doClose={hideSnackbar}
				guidedBtn={openSnackbar.guidedBtn}
				type={openSnackbar.type}
			/>
		</Box>
	);
};

PeviewElements.propTypes = {
	setSelectedListCount: PropTypes.func.isRequired,
	selectedListCount: PropTypes.shape({}).isRequired,
	setTotalSelected: PropTypes.func.isRequired
};

export default PeviewElements;
